var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 1C12.0478 1 11.4543 1.24583 11.0168 1.68342C10.5792 2.121 10.3333 2.71449 10.3333 3.33333V12.6667C10.3333 13.2855 10.5792 13.879 11.0168 14.3166C11.4543 14.7542 12.0478 15 12.6667 15C13.2855 15 13.879 14.7542 14.3166 14.3166C14.7542 13.879 15 13.2855 15 12.6667C15 12.0478 14.7542 11.4543 14.3166 11.0168C13.879 10.5792 13.2855 10.3333 12.6667 10.3333H3.33333C2.71449 10.3333 2.121 10.5792 1.68342 11.0168C1.24583 11.4543 1 12.0478 1 12.6667C1 13.2855 1.24583 13.879 1.68342 14.3166C2.121 14.7542 2.71449 15 3.33333 15C3.95217 15 4.54566 14.7542 4.98325 14.3166C5.42083 13.879 5.66667 13.2855 5.66667 12.6667V3.33333C5.66667 2.71449 5.42083 2.121 4.98325 1.68342C4.54566 1.24583 3.95217 1 3.33333 1C2.71449 1 2.121 1.24583 1.68342 1.68342C1.24583 2.121 1 2.71449 1 3.33333C1 3.95217 1.24583 4.54566 1.68342 4.98325C2.121 5.42083 2.71449 5.66667 3.33333 5.66667H12.6667C13.2855 5.66667 13.879 5.42083 14.3166 4.98325C14.7542 4.54566 15 3.95217 15 3.33333C15 2.71449 14.7542 2.121 14.3166 1.68342C13.879 1.24583 13.2855 1 12.6667 1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.948573767fe3d1afc2f33a02d7d7dcfa.svg";
export { ForwardRef as ReactComponent };